






import { Component, Inject, Mixins } from "vue-property-decorator";
import { IContractProductProvider } from "@/models/providers/contractProduct";
import Context from "@/mixins/context";

@Component
export default class CProdStatusReasonTooltip extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  // Computed

  public get tooltip() {
    return this.$cProdData()?.contractProduct?.manual_status_reason;
  }

  public get isVisible() {
    if (!this.isAdmin) return false;
    if (!this.$cProdData().hasManualStatus) return false;
    return !!this.tooltip;
  }
}
